<p-panel [toggleable]="true">
  <ng-template #header>
    <h4>
      {{ group.itemCode }} -
      {{ group.item?.itemLongDisplayName }}
    </h4>
  </ng-template>
  <p-card data-variant="compact">
    <div class="grid-12 mb-[1rem]">
      <div class="span-8">
        <div class="grid-12">
          <div class="span-3">
            <label>
              {{ 'Yarn_Requisitions_Details_Fabric_Quantity' | translateWF: 'Fabric Quantity' }}
            </label>
            <input
              #FabricTotalQuantityInput
              type="number"
              pInputText
              class="w-full"
              [value]="selectedFabrics[index].totalQuantity"
              (keyup)="calcRequiredItems(FabricTotalQuantityInput.value, index)"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- yarns -->
    <div class="grid-12">
      <div class="span-12">
        <p-table [value]="group.entries.controls" selectionMode="single" class="table__sm">
          <ng-template #header>
            <tr class="dark__header">
              <th>Yarn</th>
              <th [style]="{ width: '100px' }">Percentage</th>
              <th>Quantity</th>
              <th>Manufacturer</th>
              <th>Manufacturer Lot Number</th>
            </tr>
          </ng-template>
          <ng-template #body let-entryFormGroup let-i="rowIndex">
            <tr class="cursor-pointer" [formGroup]="entryFormGroup">
              <td>
                ({{ entryFormGroup.value.itemCode }})
                {{ entryFormGroup.value.itemMaster.itemDisplayName }}
              </td>
              <td>{{ selectedFabrics[index].yarnDetails[i].usePercentage }}%</td>
              <td>
                <input formControlName="requiredQuantityInUnitOfMeasure" type="number" pInputText class="w-full" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-card>
</p-panel>
